import { createContext, useContext } from "react";
export var SidePanelContext = /*#__PURE__*/createContext(undefined);
export function useSidePanelContext() {
  var context = useContext(SidePanelContext);
  if (context === undefined) {
    throw new Error("useSidePanelContext must be within SidePanelContext Provider");
  }
  return context;
}